import { useEffect, useState } from "react";
import {
  Accordion,
  Col,
  Dropdown,
  Nav,
  Offcanvas,
  Row,
  Table,
  Form,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFile,
  faTrash,
  faXmark,
  faPaperclip,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import "./InvoiceOrder.css";
import "../../Utils/assets/css/styles.css";
import {
  downloadPdf,
  formatDate,
  formatToINR,
  printPdf,
  putCommaInLeadsValue,
  TextWithLineBreaks,
} from "../../Utils/helpers/commonhelper";
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import { baseURL, imageURL } from "../../Utils/constants/constant";
// import { EmailModal } from "../detailPage/leads/EmailModal";
import { WhatsappModal } from "../../CommonComponents/WhatsappModal";
import { EmailModal } from "../../Pages/detailPage/leads/EmailModal";
import { RxCrossCircled } from "react-icons/rx";
import pugcrm_logo from "./.././../Utils/assets/img/pugcrm_logo.png";
import DeleteModal from "../DeleteModal";
import nodata from "../../Utils/assets/img/leads_no_data_found.png";
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials";
import Spinner from "../../Utils/helpers/SpinLoader";
import useLocalStorageState from "use-local-storage-state";

const InvoiceDetails = ({
  setShowSalesOrderDetails,
  show,
  handleClose,
  detailPageId,
}) => {

  // getting essentials for apis
  const { customer, setCustomer, headers, extras, navigate, customerId: customer_id, loginUserId, userType } = useGetEssentials()

  const [PERMISSION] = useLocalStorageState('permission');
  // poermissions for payment received 
  const paymentGrant = PERMISSION.payment;
  const isPaymentReceived = paymentGrant?.isAuthorized;
  const isPaymentCreate = paymentGrant?.isCreate;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [paymentToDelete, setPaymentToDelete] = useState(null);
  const [loading, setLoading] = useState(false);
  // pdf view toggle
  const [pdfView, setPdfView] = useState(false);


  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPaymentList, setShowPaymentList] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // WhatsApp modal state
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [cloneData, setCloneData] = useState([]);
  const [paymentList, setPaymentList] = useState([]);

  const parsedShippingAddress = cloneData?.shipping_address
    ? JSON.parse(cloneData?.shipping_address)
    : "";


  const parsedCompanyBillingAddress = cloneData?.company_billing_address
    ? JSON.parse(cloneData?.company_billing_address)
    : "";

  const fetchDetailsOfSpecificInvoice = async () => {
    if (!detailPageId) return;
    try {
      const res = await GetRequest(
        `/invoice/fetchDetailsOfSpecificInvoice/${detailPageId}/${customer_id}/${loginUserId}`,
        { headers },
        extras,
      );

      if (res.success === false || res.status === "fail") {
        toast.error(res.message || "Error fetching details!");
        return
      }

      setCloneData(res.data[0]);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (detailPageId) {
      fetchDetailsOfSpecificInvoice();
    }
  }, [detailPageId]);

  //create payment page
  const handleAddClick = () => {
    if (!isPaymentReceived || !isPaymentCreate) {
      return toast.error("You are not authorized to record payment");
    }
    const dataToSend = {
      key1: cloneData.id,
      key2: cloneData.contact_id,
      key3: cloneData.contact_full_name,
    };
    navigate("/createpayment", { state: dataToSend });
  };

  const fetchPaymentList = async () => {
    try {
      const res = await GetRequest(
        `invoice/fetchPayments/${customer_id}/${loginUserId}/${cloneData?.id}`,
        { headers },
        extras
      );

      if (res.status !== "success" || res.status === "fail") {
        toast.error(res.message || "Something went wrong");
        return
      }
      if (res.status === "success") {
        setPaymentList(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (showPaymentList) {
      fetchPaymentList();
    }
  }, [showPaymentList]);

  const parsedBillingAddress = cloneData?.billing_address
    ? JSON.parse(cloneData.billing_address)
    : {};

  const itemsDetailsData = cloneData?.items ? JSON.parse(cloneData.items) : [];


  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
  };

  const setStopReminder = async () => {
    try {
      const payload = {
        customer_id: customer_id,
        invoice_id: cloneData?.id,
        reminder: "no",
      };
      const res = await PutRequest(
        `invoice/setReminder`,
        payload,
        { headers },
        extras
      );

      if (res.status === "fail" || res.success === false) {
        toast.error(res.message)
        return
      }
      setShowModal(false);
    } catch (error) {
      console.error(error);
    }
  };
  // Trigger delete modal
  const onDelete = (id) => {
    setPaymentToDelete(id);
    setShowDeleteModal(true);
  };
  const handleConfirmedDelete = async () => {
    try {
      const item = paymentList.find((d) => d.payment_id === paymentToDelete);
      if (!item) return;
      setLoading(true);

      const res = await DeleteRequest(
        `invoice/deletePayment/${paymentToDelete}/${loginUserId}/${customer?.customer_details?.customer_id}`,
        { headers },
        extras,
      );

      if (res?.status === "success") {
        toast.success(res.message);
        setPaymentList([]);
        await fetchPaymentList();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
      setPaymentToDelete(null);
    }
  };
  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        backdrop="static"
        className="offcanvas offcanvas-end w-75"
      >

        <div
          className="offcanvas-header align-items-center border-bottom justify-content-between py-3 px-4"
          id="saleOrderDetails"
          aria-labelledby="staticBackdropLabel"
        >
          {/* <h5 className="offcanvas-title" id="staticBackdropLabel">
            Invoice Number {cloneData.invoice_number || "-"}
          </h5> */}
          <h3
            className=" mb-0"
            style={{
              whiteSpace: "nowrap",
              fontWeight: 300,
              fontSize: "22px",
            }}
          >
            Invoice Details-
            <span className="ms-1" style={{ color: "#0099ff" }}>
              #{cloneData.invoice_number || "-"}
            </span>
          </h3>
          <div className="d-flex align-items-center">
            {/* <p><i className='bx bx-paperclip'></i></p> */}
            <label
              htmlFor="pic"
              className="divslabel me-2 btn mb-0 btn-sm btn-primary"
              style={{ borderRadius: 3 }}
            >
              <span>
                <i className="bi bi-file-earmark-arrow-up me-1"></i>
                Upload File
              </span>
              <input type="file" id="pic" className="uploadsInput" />
            </label>{" "}
            |
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>
        </div>

        <Offcanvas.Body style={{ paddingLeft: 31, paddingRight: 31 }}>
          {loading && <Spinner text="Processing..." />}
          <DeleteModal
            show={showDeleteModal}
            isLoading={loading}
            onClose={() => setShowDeleteModal(false)}
            onConfirm={handleConfirmedDelete}
          />
          <div className="row d-flex align-items-center">
            <div className="col-md-9">
              {" "}
              <ul className="list-unlisted gap-1">
                {/* <div className="d-flex align-items-center gap-1"> */}
                <Dropdown as="div" className="dropdownsWithoutToggle">
                  <Dropdown.Toggle as={Nav.Link} className="header-link">
                    <li className="listed d-flex gap-1 align-items-center px-3" style={{ color: "#0099ff", paddingLeft: "10px" }}>
                      <i className="bi bi-send"></i>
                      Send
                    </li>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                    style={{ right: "3.4rem" }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        setShowEmailModal(true);
                      }}
                    >
                      {" "}
                      Email
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        setShowWhatsappModal(true);
                      }}
                    >
                      {" "}
                      WhatsApp
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                {/* <li className="listed d-flex gap-1 align-items-center px-3" style={{ color: "#0099ff", paddingLeft: "10px" }}>
                  <i className="bi bi-share"></i>
                  Share
                </li> */}
                <Dropdown as="div" className="dropdownsWithoutToggle">
                  <Dropdown.Toggle as={Nav.Link} className="header-link">
                    <li className="listed d-flex gap-1 align-items-center px-3" style={{ color: "#0099ff", paddingLeft: "10px" }}>
                      <i className="bi bi-printer"></i>
                      PDF/Print
                    </li>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                    style={{ right: "3.4rem" }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        printPdf(
                          `${baseURL}/invoice/downloadInvoice/${customer_id}/${cloneData?.id}`,
                          headers,
                          "print",
                          `${loginUserId}`,
                          setLoading
                        );
                      }}
                    >
                      {" "}
                      Print{" "}

                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        downloadPdf(
                          `${baseURL}/invoice/downloadInvoice/${customer_id}/${cloneData?.id}`,
                          headers,
                          "download",
                          "invoice", `${loginUserId}`,
                          setLoading
                        );
                      }}
                      className="d-flex align-items-center"
                    >
                      {" "}
                      Download
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown as="div" className="dropdownsWithoutToggle">
                  <Dropdown.Toggle as={Nav.Link} className="header-link">
                    <li
                      className="listed d-flex gap-1 align-items-center px-3"
                      style={{ color: "#0099ff" }}
                    >
                      <i className="bx bx-rupee" />
                      Payment
                    </li>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="defaultDropdownLong  plusDrowpdown dropdown-menu-end"
                    style={{ right: "3.4rem" }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        handleAddClick();
                      }}
                    >
                      {" "}
                      Record Payment
                    </Dropdown.Item>

                    <Dropdown.Item
                      href={"#"}
                      className="d-flex align-items-center"
                      onClick={() => {
                        setShowPaymentList(true);
                      }}
                    >
                      {" "}
                      Payment List
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

              </ul>
            </div>
            <div className="col-md-3">
              <div className="clearfix pb-0">
                <div className="float-end so-details-preview d-flex gap-2 align-items-center">
                  <i className="preview-label" id="a45f71bf0">
                    Show PDF View
                  </i>
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="toggleShowHidePdf"
                      onChange={() => setPdfView(!pdfView)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Row
            style={{
              width: "100%",
              marginLeft: 0,
              paddingRight: 4,
            }}
            className="mt-4 mb-1"
          >
            <Col md={12} className="pe-0 ps-0">
              <Accordion
                defaultActiveKey="1"
                className="sales-order-accordion shadow-none border-0 focus-ring-0 w-100"
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="shadow-none border-0 focus-ring-0 bg-transparent">
                    Sales order details
                  </Accordion.Header>
                  <Accordion.Body className="p-0">
                    <Table className="accordion-table">
                      <thead>
                        <tr>
                          <th style={{ borderRadius: 0 }}>Sale Number</th>
                          <th>Order Date</th>
                          <th>Shipment Date</th>
                          <th>Payment Terms</th>
                          <th>Owner Name</th>
                          <th>Approve By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cloneData?.sales_order?.length > 0 ? (
                          cloneData?.sales_order?.map((sales, index) => (
                            <tr key={index}>
                              <td
                                className="text-primary"
                                style={{ cursor: "pointer" }}
                              >
                                {sales?.sale_no || "-"}
                              </td>
                              <td>
                                {formatDate(sales?.sales_order_date) || "-"}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {formatDate(sales?.shipment_date) || "-"}
                              </td>
                              <td>{sales?.payment_term || "-"}</td>
                              <td style={{ textTransform: "capitalize" }}>
                                {sales?.owner_name || "-"}
                              </td>
                              <td style={{ textTransform: "capitalize" }}>
                                {sales?.approve_by_name || "-"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={5}>No Data Found</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>

          {showPaymentList && (
            <>
              <div
                className="table custom-scroll"

              >
                {/* Header with Close button */}
                <div
                  className="d-flex justify-content-between align-items-center px-2 py-2 listStyleForContact"
                  style={{
                    // height: "auto",
                    // height:
                    //   paymentList && paymentList.length < 1 ? "150px" : "auto",
                    // overflowX:
                    //   paymentList && paymentList.length > 10 ? "auto" : "hidden",
                    // overflowY:
                    //   paymentList && paymentList.length > 10 ? "auto" : "hidden",
                    // whiteSpace: "nowrap",
                    // borderBottom: "1px solid #ccc",
                  }}
                >
                  <div style={{ fontWeight: "bold" }}>Payment List</div>
                  <FontAwesomeIcon
                    onClick={() => setShowPaymentList(false)}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      color: "red",
                    }}
                    icon={faXmark}
                  />
                </div>

                {/* Table */}
                <div
                  // ref={tableContainerRef}
                  className="listStyleForContact"
                  style={{
                    flex: 1,
                    overflow: "auto",
                    maxHeight: "300px",
                    scrollbarWidth: "thin",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
                  }}
                >
                  <Table
                    style={{
                      maxHeight: '150px',
                      overflowY: "auto",
                      flex: 1,
                      backgroundColor: "#fff"
                    }}
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Payment Number</th>
                        <th>Reference Number</th>
                        <th>Account Type</th>
                        <th>Payment Mode</th>
                        <th>Amount Received</th>
                        <th>Bank Charges</th>
                        <th>Payment Date</th>
                        <th>Payment Received on</th>
                        <th>Amount Deducted</th>
                        <th>Tax Deducted</th>
                        <th>Tds Tax Account</th>
                        <th>Attachment</th>
                        <th>
                          <FontAwesomeIcon icon={faDownload} />
                        </th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody style={{ textAlign: "start" }}>
                      {paymentList && paymentList.length > 0 ? (
                        paymentList.map((saleOrder, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{saleOrder.payment_number}</td>
                            <td
                              style={{ color: "#0099ff", cursor: "pointer" }}
                              onClick={() => setShowSalesOrderDetails(true)}
                            >
                              {saleOrder.reference_number}{" "}
                              <i className="fa-regular fa-envelope"></i>
                            </td>
                            <td>{saleOrder.account_name}</td>
                            <td>{saleOrder.payment_mode}</td>
                            <td>
                              {putCommaInLeadsValue(
                                saleOrder.amount_recevied || 0
                              )}
                              .00
                            </td>
                            <td>{saleOrder.bank_charges}</td>
                            <td>{formatDate(saleOrder.payment_date || "")}</td>
                            <td>
                              {formatDate(saleOrder.payment_recieved_on || "")}
                            </td>
                            <td>{saleOrder.amount_deducted}</td>
                            <td>{saleOrder.tax_deducted}</td>
                            <td>{saleOrder.tds_tax_account || "-"}</td>
                            <td>{saleOrder?.attachment}</td>
                            <td>
                              {saleOrder?.attachment ? (
                                <a
                                  href={`${baseURL}${saleOrder?.attachment}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    textDecoration: "none",
                                    color: "#007bff",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      cursor: "pointer",
                                      color: "grey",
                                    }}
                                    icon={faFile}
                                  />
                                </a>
                              ) : (
                                "-"
                              )}
                            </td>

                            <td
                              className="text-start "
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                //  if (!masterGrant?.isDelete) {
                                //    toast.warning("You are not authorized for this action!")
                                //    return
                                //  }

                                onDelete(saleOrder?.payment_id);
                              }}
                            >
                              <FontAwesomeIcon
                                className="text-danger"
                                icon={faTrash}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr
                          className="no-hover-row"
                          style={{
                            backgroundColor: "#ffffff",
                            marginTop: "0px !important",
                            marginBottom: "0px !important",
                          }}
                        >
                          <td colSpan={14} style={{ textAlign: "center", color: "gray" }}>
                            <div className="d-flex justify-content-center align-items-center">
                              <img
                                src={nodata}
                                alt=""
                                style={{ width: "17rem", marginTop: "0" }}
                              />
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </>
          )}


          <div
            className="border-top-light border-bottom"
            id="normalViews"
            style={{ display: pdfView ? "none" : "block" }}
          >
            <div className="row w-100 ms-0 pt-4">
              <div
                // style={{ background: "#edffed" }}
                // className="row mb-3 pt-3 ms-0 w-100 border border-1"
                className="ms-0 w-100"
                style={{ backgroundColor: "rgb(237, 255, 237)" }}
              >
                <Row className="mt-4 px-1">
                  <Col md={6}>
                    <h3
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        color: "#212529",
                      }}
                    >
                      Sales Order
                    </h3>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex align-items-end justify-content-end">
                      <span className="font-small">
                        <span style={{ fontWeight: 200 }}>Sales Order </span>
                        <strong className="font-small">
                          #{cloneData?.sale_no || "-"}
                        </strong>
                      </span>
                    </div>
                  </Col>
                </Row>
                <hr />

                {/* Details Body */}
                <Row className="ms-0 w-100">
                  {/* Left Column: General Info */}
                  <Col md={6} className="ps-0 mb-4">
                    <h3
                      className="pt-0 mb-2 ps-2"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                        marginBottom: 14,
                        color: "#0099ff",
                      }}
                    >
                      Customer Details
                    </h3>
                    <div style={{ borderRadius: 4 }} className="ps-2">
                      <Row>
                        <Col md={12}>
                          <Form.Group className="mb-0" controlId="formCustomer">
                            <div className="d-flex align-items-center gap-2 mb-1">
                              <span
                                style={styles.cardLabel}
                                className="text-secondary"
                              >
                                Customer Name
                              </span>
                              <p
                                className="text-primary"
                                style={styles.cardLebelData}
                              >
                                <span className="pe-1 fw-semibold">:</span>
                                {cloneData?.contact_full_name || "-"}
                              </p>
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formOrderDate"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Order Date
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {/* {formatDate(salesDetails?.sales_order_date)} */}
                              {formatDate(cloneData?.invoice_date) || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formShipmentDate"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Shipment Date
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {/* {formatDate(salesDetails?.shipment_date)} */}
                              {formatDate(cloneData?.shipment_date) || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formSalesperson"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Sales Person
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {/* {salesDcloneDataetails?.owner_name || "-"} */}
                              {cloneData?.sales_person_name || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={12}>
                          <Form.Group
                            className="mb-1 d-flex gap-2 align-items-center"
                            controlId="formPaymentTerms"
                          >
                            <span
                              style={styles.cardLabel}
                              className="text-secondary"
                            >
                              Payment Terms
                            </span>
                            <p style={styles.cardLebelData}>
                              <span className="pe-1 fw-semibold">:</span>
                              {/* {salesDetails?.payment_term || "-"} */}
                              {cloneData?.payment_terms || "-"}
                            </p>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </Col>

                  {/* Right Column: Addresses */}
                  <Col
                    md={6}
                    className="mb-4 d-flex flex-column ms-0 align-items-end"
                    style={{ textAlign: "end", paddingRight: "0.3rem" }}
                  >
                    {/* Billing Address */}
                    <div style={{ borderRadius: 4 }}>
                      <h3
                        className="pt-0 mb-2"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          marginBottom: 14,
                          color: "#0099ff",
                        }}
                      >
                        Billing Address
                      </h3>
                      <div className="mt-0 mb-2 col-md-12">
                        <div className="w-100 mb-3">
                          {parsedBillingAddress === null ? (
                            <p className="fs-13 text-muted">
                              No Billing Address
                            </p>
                          ) : (
                            <>
                              <div
                                style={{ fontSize: "13px", fontWeight: 300 }}
                              >
                                <p
                                  style={{ fontSize: "13px", fontWeight: 300 }}
                                >
                                  {" "}
                                  {parsedBillingAddress?.address &&
                                    parsedBillingAddress?.address}
                                </p>
                                <p
                                  className="mb-3"
                                  style={{ fontSize: "13px", fontWeight: 300 }}
                                >
                                  {parsedBillingAddress?.city &&
                                    `${parsedBillingAddress?.city}`}
                                  {parsedBillingAddress?.state &&
                                    `, ${parsedBillingAddress?.state}`}
                                  {parsedBillingAddress?.country &&
                                    `, ${parsedBillingAddress?.country}`}
                                  {parsedBillingAddress?.zipcode &&
                                    `, ${parsedBillingAddress?.zipcode}`}
                                </p>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Shipping Address */}
                    <div className="">
                      <h3
                        className="pt-2 mb-2"
                        style={{
                          whiteSpace: "nowrap",
                          fontWeight: 300,
                          fontSize: "19px",
                          marginBottom: 14,
                          color: "#0099ff",
                        }}
                      >
                        Shipping Address
                      </h3>

                      {parsedShippingAddress ? (
                        <>
                          {/* <div className="mb-0 fs-14 text-dark">
                            <span className="d-block fs-14 text-dark fw-bold">
                              {parsedShippingAddress?.attention ||
                                cloneData?.contact_full_name}
                            </span>
                          </div> */}
                          <div style={{ fontSize: "13px", fontWeight: 300 }}>
                            <p style={{ fontSize: "13px", fontWeight: 300 }}>
                              {" "}
                              {parsedShippingAddress?.address &&
                                parsedShippingAddress?.address}{" "}
                            </p>{" "}
                            <p
                              className="mb-3"
                              style={{ fontSize: "13px", fontWeight: 300 }}
                            >
                              {parsedShippingAddress?.city &&
                                `${parsedBillingAddress?.city}`}
                              {parsedShippingAddress?.state &&
                                `, ${parsedShippingAddress?.state}`}
                              {parsedShippingAddress?.country &&
                                `, ${parsedShippingAddress?.country}`}
                              {parsedShippingAddress?.zipcode &&
                                `, ${parsedShippingAddress?.zipcode}`}
                            </p>
                          </div>
                        </>
                      ) : (
                        <p className="fs-13 text-muted">Same as Billing</p>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>

              {/* 🔽 Status Section */}
              <div className="row mt-3 mb-3">
                <h3
                  className="ps-0 mb-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                    color: "#0099ff",
                  }}
                >
                  Status
                </h3>

                <div className="col-md-4 mb-2">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Payment
                    </p>
                    <p className="fw-semibold text-dark text-uppercase">
                      {" "}

                      {(Number(itemsDetailsData[0]?.["grand-total"] || 0) ||
                        0) -
                        (Number(cloneData?.payment_amount) || 0) !==
                        0 ? (
                        <>
                          <a
                            href="#"
                            onClick={(e) => e.preventDefault()}
                            style={{
                              fontSize: "14px",
                              color: "#ac5050",
                              letterSpacing: "0.4px",
                              padding: "0px",
                            }}
                          >
                            Pending
                          </a>
                        </>
                      ) : (
                        <a
                          href="#"
                          onClick={(e) => e.preventDefault()}
                          style={{
                            fontSize: "14px",
                            color: "rgb(91 142 85)",
                            letterSpacing: "0.4px",
                            padding: "0px",
                          }}
                        >
                          Paid
                        </a>
                      )}
                    </p>
                  </div>
                </div>

                {/* CARD 4: SHIPMENT (Updated) */}
                <div className="col-md-4 mb-2">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Amount
                    </p>
                    <p className="fw-semibold text-dark">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        style={{
                          fontSize: "14px",
                          color: "rgb(91 142 85)",
                          letterSpacing: "0.4px",
                          padding: "0px",
                        }}
                      >
                        {formatToINR(
                          Number(itemsDetailsData[0]?.["grand-total"] || 0) || 0
                        )}
                      </a>
                    </p>
                  </div>
                </div>

                <div className="col-md-4 mb-2">
                  <div style={styles.cardDiv}>
                    <p style={styles.lableText} className="mb-2">
                      Due Amount
                    </p>
                    <p className="fw-semibold text-dark">
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        style={{
                          fontSize: "14px",
                          color: "#ac5050",
                          letterSpacing: "0.4px",
                          padding: "0px",
                        }}
                      >
                        {formatToINR(
                          Number(itemsDetailsData[0]?.["grand-total"] - cloneData?.payment_amount) ||
                          Number(itemsDetailsData[0]?.["grand-total"]) || 0,
                        )}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <Row
              id="itemsDetailsSection"
              style={{ width: "100%", marginLeft: 0, paddingRight: 4 }}
            >
              <h3
                className="ps-0 mb-3"
                style={{
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  fontSize: "19px",
                  color: "#0099ff",
                }}
              >
                Items Details
              </h3>

              <Col md={12} className="pe-0 ps-0">
                <div className="table-responsive quatationsTables2 mb-3 ">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }} className="text-start">
                          Items &amp; Description
                        </th>
                        <th style={{ width: "10%" }} className="text-end">
                          Quantity
                        </th>
                        <th style={{ width: "11%" }} className="text-end">
                          GST(
                          <i className="bi bi-percent"></i>)
                        </th>
                        <th style={{ width: "11%" }} className="text-end">
                          Rate(<i className="ti ti-currency-rupee"></i>)
                        </th>
                        <th style={{ width: "16%" }} className="text-end">
                          Discount(
                          <i className="bi bi-percent"></i>/
                          <i className="ti ti-currency-rupee"></i>)
                        </th>
                        <th
                          style={{ width: "11%" }}
                          className="text-center pe-2"
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemsDetailsData[0]?.itemDetails?.map((item, index) => (
                        <tr key={index}>
                          <td className="text-start">
                            <div>
                              <p
                                className="w-100 mb-0 d-flex fs-13 align-items-center text-dark justify-content-between"
                                style={{
                                  fontWeight: 500,
                                  textTransform: "capitalize",
                                  width: "auto",
                                }}
                              >
                                {" "}
                                {item.name ?? "-"}
                              </p>
                              <p className="mb-0" style={{ cursor: "pointer" }}>
                                {item.itemDescription || "-"}{" "}
                              </p>
                            </div>
                          </td>
                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-2 pt-0 fs-13"
                            >
                              {item?.quantity ?? "-"}{" "}
                            </span>
                          </td>
                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-3 pt-0 fs-13"
                            >
                              {item?.gst ?? "-"}
                              <i className="bi bi-percent"></i>
                            </span>
                          </td>
                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-2 pt-0 fs-13"
                            >
                              {formatToINR(item?.Rate ?? "-")}
                            </span>
                          </td>

                          <td className="text-end">
                            <span
                              style={styles.valuesStyle}
                              className="me-3 pt-0 fs-13"
                            >
                              {item.discount}
                              {item.discountType === "Percentage" ? (
                                <i className="bi bi-percent"></i>
                              ) : (
                                <i className="ti ti-currency-rupee"></i>
                              )}
                            </span>
                          </td>

                          <td className="text-end">
                            <div className="d-flex gap-2 align-items-center justify-content-center pe-3">
                              <div
                                className="fs-14 text-end"
                                style={{ fontWeight: 500, fontSize: 14 }}
                              >
                                {formatToINR(item.discountedAmount ?? "-")}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}

                      <tr>
                        <th
                          className="text-start bg-transparent border-0 vertical-top w-100"
                          style={{ verticalAlign: "top" }}
                        >
                          <div className="mt-3 mb-3">
                            <p
                              className="ps-1 mb-2 fs-14"
                              style={{ fontWeight: 400 }}
                            >
                              Customer Note
                            </p>
                            <p className=" ps-1 text-wrap fs-13 fw-normal">
                              {cloneData?.customer_note ?? "-"}
                            </p>
                          </div>
                        </th>
                        <th
                          colSpan={5}
                          className="text-start bg-transparent border-0 "
                        >
                          <div
                            className=" w-100 h-100 mt-3 mb-3 "
                            style={{
                              borderRadius: 5,
                              background: "#f9f9fb",
                              padding: "1rem",
                            }}
                          >
                            <div className="row sub-total mb-2 ">
                              <div className="total-label col-md-6 d-flex align-items-center fs-14 fw-500">
                                Sub Total
                              </div>
                              <div className="total-amount text-end fs-14 fw-500  col-md-6 d-flex align-items-center gap-1 justify-content-end">
                                {/* {formatToINR(items[0]?.subTotal)} */}
                                {formatToINR(
                                  itemsDetailsData[0]?.["sub-total"] || 0
                                )}
                              </div>
                            </div>

                            <div className="row sub-total mb-1">
                              <div className="total-label col-md-4 d-flex text-secondary fw-400 align-items-center fs-13">
                                Special Discount
                                <span className="ps-1 fs-13">
                                  ({itemsDetailsData[0]?.special_discount}
                                  <span className="pe-1">
                                    <i>
                                      {
                                        itemsDetailsData[0]
                                          ?.special_DiscountType
                                      }
                                    </i>
                                  </span>
                                  )
                                </span>
                              </div>

                              <div className="total-amount text-end fs-13 text-secondary fw-400 col-md-8 d-flex align-items-center justify-content-end">
                                -
                                {formatToINR(
                                  itemsDetailsData[0]
                                    ?.special_Discount_Amount || 0
                                )}
                              </div>
                            </div>
                            <div className="row sub-total mb-1">
                              <div className="total-label col-md-4 d-flex align-items-center text-secondary fw-400 fs-13">
                                Shipping Charge
                              </div>
                              <div className="total-amount text-end col-md-5 justify-content-center d-flex gap-1">
                                <span></span>
                              </div>

                              <div className="total-amount text-end text-secondary fw-400 fs-13 col-md-3 d-flex align-items-center gap-1 justify-content-end">
                                {formatToINR(
                                  itemsDetailsData[0]?.shipping_Charge || 0
                                )}
                              </div>
                            </div>

                            <div>
                              {itemsDetailsData[0]?.gstBreakdown?.map((gst) => (
                                <div
                                  className="row sub-total mb-2"
                                  key={gst?.gst}
                                >
                                  <div className="total-label col-md-4 d-flex align-items-center text-secondary fw-400 fs-13">
                                    GST
                                    <span className="ps-1 fs-13">
                                      ({gst?.gst}%)
                                    </span>
                                  </div>
                                  <div className="total-amount text-end text-secondary fw-400 col-md-8 fs-13 d-flex align-items-center justify-content-end gap-1">
                                    {formatToINR(
                                      Number(`${gst?.amount}`).toFixed(2)
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>

                            <hr />
                            <div className="row sub-total ">
                              <div className="total-label col-md-6 fw-500 fs-14">
                                Grand Total
                              </div>
                              <div className="total-amount text-end text-semibold col-md-6 fw-500 fs-14">
                                {formatToINR(
                                  itemsDetailsData[0]?.["grand-total"] || 0
                                )}
                              </div>
                            </div>
                          </div>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>

            {/* 🔽 Total Section */}
            <Row id="termsAndConditionsSec" className="mt-3">
              <Col md={8}>
                <h3
                  className=" mb-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                    color: "#0099ff",
                  }}
                >
                  Terms & Conditions
                </h3>

                <Form.Group className="mb-3" controlId="formTerms">
                  <p className="ps-1 mb-2 fs-13" style={{ fontWeight: 400 }}>
                    {cloneData?.terms_condition
                      ? TextWithLineBreaks(cloneData?.terms_condition)
                      : "Terms and conditions not available"}
                  </p>
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <h3
                  className=" mb-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                    color: "#0099ff",
                  }}
                >
                  Attachment
                </h3>
                <div
                  style={{
                    borderRadius: "10px",
                    padding: "10px 0px",
                    textAlign: "start",
                    width: "100%",
                    maxWidth: "400px",
                    margin: "0px",
                  }}
                >
                  <p
                    style={{ marginBottom: "5px", color: "#666" }}
                    className="d-flex align-items-center"
                  >
                    <FontAwesomeIcon
                      icon={faPaperclip}
                      className="me-2 fs-20"
                      style={{ color: "#0099ff", flexShrink: 0 }}
                    />
                    {cloneData?.attachment ? (
                      <a
                        href={`${imageURL}${cloneData?.attachment}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#0099ff",
                          textDecoration: "underline",
                          /* --- START FIX --- */
                          wordBreak: "break-all", // Forces the text to break anywhere necessary
                          overflowWrap: "anywhere", // Ensures it wraps within the container
                          /* --- END FIX --- */
                        }}
                      >
                        {cloneData?.attachment.split("/").pop()}
                      </a>
                    ) : (
                      "No attachment"
                    )}
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          {/* toggle pdf view */}
          <div
            className="card shadow mt-4"
            id="pdfsViews"
            style={{ display: pdfView ? "block" : "none" }}
          >
            <div className="card-body pt-0">
              <div className="row w-100 ms-0">
                {/* --- Header: Logo & Title --- */}
                <div className="col-md-6 ps-0">
                  {/* Assuming you have access to the logo variable here. 
            If not, import it or use a text placeholder */}
                  <img
                    src={pugcrm_logo}
                    alt="logo"
                    style={{ height: "130px", width: "160px" }}
                  />
                </div>
                <div className="col-md-6 d-flex align-items-center justify-content-end ps-0">
                  <h2 className="mb-1">INVOICE</h2>
                </div>
              </div>

              {/* --- Address & Details Section (3 Columns) --- */}
              <div className="ms-2 mt-4 mb-4 d-flex justify-content-between">
                <div className=" d-flex align-items-start justify-content-start flex-column">
                  <p className="mb-2 fw-semibold fs-14">Billed By</p>
                  <p className="mb-1 text-black fw-semibold">
                    {cloneData?.company_name && cloneData?.company_name}
                  </p>
                  <p className="mb-1 fs-13">
                    {parsedCompanyBillingAddress.length > 0 ||
                      parsedCompanyBillingAddress !== null ||
                      parsedCompanyBillingAddress !== undefined ? (
                      <>
                        <p className="mb-1 fs-13">
                          {parsedCompanyBillingAddress[0]?.address &&
                            parsedCompanyBillingAddress[0]?.address}
                        </p>
                        <p className="mb-1 fs-13">
                          <p className="mb-1 fs-13">
                            {[
                              parsedCompanyBillingAddress[0]?.city,
                              parsedCompanyBillingAddress[0]?.state,
                              parsedCompanyBillingAddress[0]?.country,
                              parsedCompanyBillingAddress[0]?.zipcode,
                            ]
                              .filter(Boolean)
                              .join(", ")}
                          </p>
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="fs-13 mb-1">{cloneData?.address}</p>
                        <p className="fs-13 mb-1">
                          {cloneData?.city_name && `${cloneData.city_name}`}
                          {cloneData?.state_name && `, ${cloneData.state_name}`}
                          {cloneData?.nicename && `, ${cloneData.nicename}`}
                          {cloneData?.zipcode && `, ${cloneData.zipcode}`}
                        </p>
                      </>
                    )}
                  </p>
                </div>
                <div className="">
                  <p className="mb-2 fw-semibold fs-14">Billed To</p>
                  <p className="mb-1 text-black fw-semibold">
                    {cloneData?.contact_full_name &&
                      cloneData?.contact_full_name}
                  </p>
                  <p className="mb-1 fs-13">
                    {parsedBillingAddress?.address &&
                      parsedBillingAddress.address}{" "}
                  </p>
                  <p className="mb-1 fs-13">
                    {parsedBillingAddress?.city &&
                      `${parsedBillingAddress.city}`}
                    {parsedBillingAddress?.state &&
                      `, ${parsedBillingAddress.state}`}
                    {parsedBillingAddress?.country &&
                      `, ${parsedBillingAddress.country}`}
                    {parsedBillingAddress?.zipcode &&
                      `, ${parsedBillingAddress.zipcode}`}
                  </p>
                  {/* <p className="mb-1 fs-13">{salesDetails?.email || "email"}</p> */}
                </div>
                {/* Col 3: Invoice Details */}
                <div className="">
                  <p className="mb-2 fw-semibold fs-14">Invoice Details</p>
                  <p className="mb-1 fs-13">
                    Invoice No.:
                    <span className="fs-14 ms-1 fw-semibold text-black">
                      #{cloneData?.invoice_number || "-"}
                    </span>
                  </p>
                  <p className="mb-1 fs-13">
                    Invoice Date:
                    <span className="fs-14 ms-1 fw-semibold text-black">
                      {formatDate(cloneData?.invoice_date) || "-"}
                    </span>
                  </p>
                  <p className="mb-1 fs-13">
                    Shipment Date:
                    <span className="fs-14 ms-1 fw-semibold text-black">
                      {formatDate(cloneData?.shipment_date) || "-"}
                    </span>
                  </p>
                </div>
              </div>

              {/* --- Items Table Section --- */}
              <div className="row">
                <div
                  id="itemsDetailsSection"
                  style={{ width: "100%", marginLeft: 0, paddingRight: 4 }}
                >
                  <div className="col-md-12 pe-0 ps-0">
                    <div className="table-responsive quatationsTables2 mb-3">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th
                              className="text-start"
                              style={{ height: "2rem" }}
                            >
                              Items & Description
                            </th>

                            {/* <th style={{ width: "11%" }} className="text-end">
                              HSN/SAC
                            </th> */}
                            <th className="text-end" style={{ height: "2rem" }}>
                              GST Rate(
                              <i className="bi bi-percent"></i>)
                            </th>
                            <th className="text-end" style={{ height: "2rem" }}>
                              Quantity
                            </th>
                            <th className="text-end" style={{ height: "2rem" }}>
                              Rate(<i className="ti ti-currency-rupee"></i>)
                            </th>
                            <th className="text-end" style={{ height: "2rem" }}>
                              Discount(
                              <i className="bi bi-percent"></i>/
                              <i className="ti ti-currency-rupee"></i>)
                            </th>
                            <th
                              className="text-end "
                              style={{ height: "2rem" }}
                            >
                              IGST(
                              <i className="bi bi-percent"></i>)
                            </th>
                            {/* Kept Discount/Tax cols commented out if you want to enable them later like Sales Order */}
                            {/* <th style={{ width: "11%" }} className="text-end">Tax %</th> */}
                            <th
                              className="text-center pe-2"
                              style={{ height: "2rem" }}
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {itemsDetailsData[0]?.itemDetails?.map(
                            (item, index) => (
                              <tr key={index}>
                                <td className="text-start">
                                  <div>
                                    <p
                                      className="mb-0 w-100 d-flex fs-13 align-items-center justify-content-between"
                                      style={{ fontWeight: 500, width: "auto" }}
                                    >
                                      {item.name ?? "-"}
                                    </p>
                                    <p
                                      className="mb-0 text-muted"
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "13px",
                                        width: "auto",
                                      }}
                                    >
                                      {item.description || "-"}
                                    </p>
                                  </div>
                                </td>
                                {/* <td className="text-end">
                                  <span
                                    style={styles.valuesStyle}
                                    className="me-3 pt-0"
                                  >
                                    Code
                                  </span>
                                </td> */}
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-3 pt-0"
                                  >
                                    {item?.gst ?? "-"}
                                  </span>
                                </td>
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-2 pt-0"
                                  >
                                    {item?.quantity ?? "-"}{" "}
                                  </span>
                                </td>
                                {/* <td className="text-end">
                                  <span
                                    className="me-2 pt-0"
                                    style={{ fontSize: "13px" }}
                                  >
                                    {item.quantity ?? "-"}{" "}
                                    <span className="text-muted font-xxs">
                                      pcs
                                    </span>
                                  </span>
                                </td> */}

                                <td className="text-end">
                                  <span
                                    className="me-2 pt-0"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {formatToINR(item.Rate ?? "-")}
                                  </span>
                                </td>

                                {/* Example Tax Column matching Sales Order style */}
                                {/* <td className="text-end">
                        <span className="me-3 pt-0">{item?.gst ?? "-"}%</span>
                    </td> */}
                                <td className="text-end">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-3 pt-0"
                                  >
                                    {item.discount}
                                    {item.discountType === "Percentage" ? (
                                      <i className="bi bi-percent"></i>
                                    ) : (
                                      <i className="ti ti-currency-rupee"></i>
                                    )}
                                  </span>
                                </td>
                                <td className="text-end ">
                                  <span
                                    style={styles.valuesStyleForPdf}
                                    className="me-3 pt-0"
                                  >
                                    {item?.gst ?? "-"}
                                    <i className="bi bi-percent"></i>
                                  </span>
                                </td>
                                <td className="text-end">
                                  <div className="d-flex gap-2 align-items-center justify-content-center">
                                    <div
                                      className="fs-12 text-end pe-2"
                                      style={{ fontWeight: 500 }}
                                    >
                                      {formatToINR(
                                        item.discountedAmount ?? "-"
                                      )}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* --- Footer & Totals Section --- */}
              <div className="row mt-3" id="termsAndConditionsSec">
                {/* Left Side: Notes & Terms */}
                <div className="col-md-6 pt-2">
                  <div className="d-flex flex-column">
                    <div>
                      <h3
                        className="mb-2 fs-14"
                        style={{ whiteSpace: "nowrap", fontWeight: 400 }}
                      >
                        Terms & Conditions
                      </h3>
                      {/* Assuming you have terms in cloneData, or hardcode them */}
                      <p className="mb-2 fs-13" style={{ fontWeight: 400 }}>
                        {cloneData.terms_condition || "Standard terms apply."}
                      </p>
                    </div>
                    {cloneData.customer_note && (
                      <div className="mt-1 mb-3">
                        <h3
                          className="mb-2 fs-14"
                          style={{ whiteSpace: "nowrap", fontWeight: 400 }}
                        >
                          Additional Notes
                        </h3>
                        <p className="text-wrap fs-13 fw-normal">
                          {cloneData.customer_note}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Side: Totals Calculation (Papayawhip Background) */}
                <div className="col-md-6">
                  <div
                    style={{
                      backgroundColor: "papayawhip",
                      borderRadius: "4px",
                    }}
                  >
                    <div className="text-start border-0">
                      <div className="w-100 h-100">
                        <div style={{ padding: "1rem" }}>
                          <div className="row sub-total mb-2 text-semibold ">
                            <div className="total-label fw-semibold col-md-7 d-flex fs-14 align-items-center">
                              Amount
                            </div>
                            <div className="total-amount fs-14 text-end fw-semibold col-md-5 d-flex align-items-center gap-1 justify-content-end">
                              {/* {formatToINR(items[0]?.subTotal)} */}
                              {formatToINR(
                                itemsDetailsData[0]?.["sub-total"] || 0
                              )}
                            </div>
                          </div>
                          <div className="row sub-total mb-1">
                            <div className="total-label col-md-7 fs-13 d-flex  align-items-center">
                              Special Discount
                              <span className="ps-1 fs-13">
                                ({itemsDetailsData[0]?.special_discount}
                                <span className="pe-1">
                                  <i>
                                    {itemsDetailsData[0]?.special_DiscountType}
                                  </i>
                                </span>
                                )
                              </span>
                            </div>

                            <div className="total-amount text-end fs-13 text-semibold col-md-5 d-flex align-items-center justify-content-end">
                              -
                              {formatToINR(
                                itemsDetailsData[0]?.special_Discount_Amount ||
                                0
                              )}
                            </div>
                          </div>
                          <div>
                            {itemsDetailsData[0]?.gstBreakdown?.map((gst) => (
                              <div
                                className="row sub-total mb-1"
                                key={gst?.gst}
                              >
                                <div className="total-label col-md-7 d-flex align-items-center fs-13">
                                  IGST
                                  <span className="ps-1 fs-13">
                                    ({gst?.gst}%)
                                  </span>
                                </div>
                                <div className="total-amount text-end col-md-5 fs-13 d-flex align-items-center justify-content-end gap-1">
                                  {formatToINR(
                                    Number(`${gst?.amount}`).toFixed(2)
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="row sub-total mb-1">
                            <div className="total-label col-md-7 d-flex align-items-center fs-13">
                              Shipping Charge
                            </div>
                            <div className="total-amount fs-13 text-end text-semibold col-md-5 d-flex align-items-center gap-1 justify-content-end">
                              {formatToINR(
                                itemsDetailsData[0]?.shipping_Charge || 0
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Grand Total Bar (Blue) */}
                        <div
                          className="row sub-total fw-semibold py-2 mx-0"
                          style={{
                            backgroundColor: "rgb(0, 153, 255)",
                            color: "#ffff",
                            borderBottomLeftRadius: "4px",
                            borderBottomRightRadius: "4px",
                          }}
                        >
                          <div className="total-label fw-semibold fs-14 col-md-6 ps-3">
                            Total
                          </div>
                          <div className="total-amount fs-14 text-end fw-semibold col-md-6 pe-3">
                            {formatToINR(
                              itemsDetailsData[0]?.["grand-total"] || 0
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* --- Signature --- */}
              <div className="mt-4 fs-13 ps-0">
                <p>Authorised Signature _________________</p>
              </div>
            </div>
          </div>

          {showModal && (
            <>
              <div
                className="modal  show fade d-block"
                tabIndex="-1"
                role="dialog"
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog" role="document">
                  <div
                    className="modal-content "
                    style={{ marginTop: "120px" }}
                  >
                    <div className="modal-header d-flex justify-content-between">
                      <h5 className="modal-title">Stop Remender</h5>
                      <button
                        type="button"
                        className="btn"
                        style={{
                          background: "none",
                          border: "none",
                          fontSize: "1.8rem",
                          cursor: "pointer",
                          color: "#888",
                          marginTop: "-20px",
                          opacity: "0.4",
                        }}
                        onClick={() => setShowModal(false)}
                      >
                        <RxCrossCircled />
                      </button>
                    </div>

                    <div className="modal-body">
                      Are you sure you want to stop the reminder?
                    </div>

                    <div className="modal-footer" style={{ borderTop: "none" }}>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={() => {
                          setStopReminder();
                        }}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      <style jsx>
        {`
          .sales-order-accordion .accordion-button:not(.collapsed) {
            background-color: #ffffff;
            box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0
              var(--bs-accordion-border-color);
            color: var(--bs-accordion-active-color);
          }

          .list-unlisted {
            list-style: none !important;
            display: flex !important;
            width: fit-content !important;
            text-align: center !important;
            border-bottom: none !important;
            background-color: #ffffff !important;
            margin-bottom: 0px !important;
            width: 100% !important;
            padding-left: 0px !important;
            border-top: none !important;
          }

          .list-unlisted .listed {
            padding: 6px 12px !important;
            border-left: 1px solid #ebeaf2 !important;
            font-size: 13px !important;
            cursor: pointer !important;
            background: #e9e9e9 !important;
            color: #373636 !important !important;
            border-radius: 3px !important;
          }

          .quatationsTables2 table thead tr th {
            font-size: 0.8rem !important;
            background: #dbdbdb57 !important;
            padding: 0px 16px !important;
            height: 2.5rem;
            font-family: "Inter", sans-serif !important;
            line-height: 1.5;
            letter-spacing: 0.0573rem;
            border-bottom: 1px solid #d8e6f7 !important;
            border-radius: 0px !important;
          }

          .quatationsTables2 table thead tr th:first-child {
            border-top-left-radius: 0px !important;
            /* width: 60px; */
            text-align: center;
            background: #dbdbdb57 !important;
            font-weight: 300;
            color: black !important;
          }
          .quatationsTables2 .table thead {
            position: relative;
            height: auto !important;
            top: 0px;
          }
          .quatationsTables2 table tbody tr td {
            font-size: 13px !important;
          }
          .quatationsTables2 table tbody tr:last-child th:first-child {
            border-right: none !important;
          }
          .quatationsTables2 table thead tr th:last-child {
            border-top-right-radius: 0px !important;
            /* width: 60px; */
            text-align: center;
            /* background: #dbdbdb57 !important; */
            font-weight: 300;
            color: black !important;
          }

          .quatationsTables2.table-responsive {
            border: 1px solid lightblue !important;
            border-radius: 5px !important;
          }

          .quatationsTables2.table-responsive table {
            border-radius: 5px !important;
          }

          .quatationsTables2 tr th {
            padding: 10px 7px 10px 10px !important;
            border-right: 1px solid #bababa !important;
          }

          .quatationsTables2 tr td {
            padding: 7px 7px 7px 15px !important;
            border-bottom: 1px solid #d1e9f1 !important;
            border-right: 1px solid #bababa !important;
          }

          .accordion-table thead {
            position: relative !important;
            height: auto !important;
            top: 0px;

          }
        `}
      </style>

      {showEmailModal && (
        <EmailModal
          show={showEmailModal}
          onClose={handleCloseEmailModal}
          id={cloneData?.id}
          pipelineId={""}
          customerId={customer_id}
          loginId={loginUserId}
          headers={headers}
          extras={extras}
          data={cloneData} // Pass lead data for pre-populating emails
          module_name={"invoice"}
        />
      )}

      {/* WhatsApp Modal */}
      {showWhatsappModal && (
        <WhatsappModal
          whatsappModalOpen={showWhatsappModal}
          setWhatsAppModalOpen={setShowWhatsappModal}
          id={cloneData?.id}
          module_name={"invoice"}
        />
      )}

      {/*payment list modal */}
    </>
  );
};

const styles = {
  valuesStyle: {
    marginBottom: 0,
    paddingTop: 4,
    paddingLeft: 0,
    fontSize: "0.77rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 400,
    color: "black",
  },
  valuesStyleForPdf: {
    marginBottom: 0,
    paddingTop: 4,
    paddingLeft: 0,
    fontSize: "0.75rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 400,
    color: "black",
  },
  valuesStyle1: {
    marginBottom: 0,
    paddingTop: 25,
    paddingLeft: 13,
    fontSize: "0.87rem",
    lineHeight: 1.6,
    borderRadius: "0.35rem",
    fontWeight: 500,
    color: "black",
    cursor: "pointer",
  },
  lableText: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    lineHeight: "normal",
    fontSize: "13px",
    fontWeight: 300,
  },
  cardDiv: {
    border: "1px solid lightblue",
    borderRadius: "3px",
    padding: "18px 18px",
    lineHeight: "0.6rem",
  },
  cardLabel: {
    marginBottom: 1,
    fontSize: "13px",
    fontWeight: 300,
    minWidth: "125px",
  },
  cardLebelData: {
    textTransform: "capitalize",
    color: "black",
    fontWeight: 400,
    fontSize: "13px",
  },
};

export default InvoiceDetails;
